export enum PermissionRequestType
{
    VehicleBilling,
    VehicleDelivery,
    Contract,
    PropertyRelease,
    Delete,
    Postsale,
    Unlock
}